'use strict'

import React      from 'react'
import $          from 'jquery'
import ButtonPage from '../assets/button-page'

export default class LastVisit extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      lastTreatment: [
        'Less than 2 years',
        '2 - 5 years',
        '5 - 10 years',
        '10+ years'
      ]
    }
  }

  dentistVisit (e) {
    const { onChange, nextPage } = this.props

    window.ga('send', 'event', {
      eventCategory: 'Dental Question',
      eventAction: 'Click',
      eventLabel: 'Timeframe'
    })

    onChange('last-visit', {
      displayName: 'Last Visit',
      value: $(e.target).attr('data-option'),
      pageRef: '',
      order: 5,
      displayInSummary: true
    })

    nextPage()
  }

  render () {
    const { lastTreatment } = this.state
    const { summary } = this.props

    let activeValue = (summary['last-visit']) ? summary['last-visit'].value : ''

    return (
      <div className="last-visit">
        <h2 className="header outline">History</h2>
        <h2 className="summary-question">How long has it been since you saw a dentist?</h2>
        <ButtonPage buttons={lastTreatment} onClick={this.dentistVisit.bind(this)} activeValue={activeValue} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/form-segments/last-visit.js